import React from 'react';
import { connect } from 'react-redux';
import {
    getHardwareOptions,
    getSelectedHardwareOption,
    getCmsContent, getAccessType
} from '@/redux/fitting-hardware';

import {
    ReduxStateType,
    HardwareOptionType,
    CmsPageContentType,
    CmsPageContentIdentifier, CmsRouterContentIdentifier, HardwareClass,
} from '@/types/fitting-hardware';
import HardwareTile from "@/components/fitting-hardware/HardwareSelection/HardwareTitle";
import OwnRouterComponent from "@/components/fitting-hardware/HardwareSelection/own-router-component";
import ItemPanel from "@/components/fitting-hardware/HardwareSelector/Item/ItemPanel";

export interface StateProps {
    hardwareOptions: HardwareOptionType[]
    selectedHardwareOption?: HardwareOptionType
    cmsContent: CmsPageContentType
    accessType: string
}

export interface HardwareSelectionProps {
    onHardwareOptionSelected: (index: number, hardwareOption: HardwareOptionType) => void
    isFmsTariff: boolean
    onBuyHardwareTeaserClick: VoidFunction
}

const HardwareSelection = ({ hardwareOptions,
                               onHardwareOptionSelected,
                               cmsContent,
                               accessType,
                               isFmsTariff,
                               onBuyHardwareTeaserClick,
                           selectedHardwareOption}: StateProps & HardwareSelectionProps) => {

    if (hardwareOptions.length <= 0) {
        return null;
    }
    const style = `
        .combi-router-section .combi-router-section-header {
            display:none;
        }
    
        .combi-router-section .combi-router-section-header:first-child {
            display:block;
        }
        
        .router-ont-section .router-ont-section-header {
            display:none;
        }
    
        .router-ont-section .router-ont-section-header:first-child {
            display:block;
        }
        
        .router-section-header{
            font-weight : 700;
            font-size : 24px;
            line-height : 28.8px;
            font-family: 'On Air';
            margin-top: 4px;
            margin-bottom: 16px
        }
        
        .product-details > p{
        margin: 0px
        }
        
        .product-details > p >a {
        margin: 0px !important
        }
        
         @media only screen and (min-width: 768px) {
  .hardware-tile, .hardware-tile-checked {
    display: flex;
    padding: 24px;
    box-sizing: border-box;
    border-radius: 4px;
    background-color: #FFFFFF;
    cursor: pointer;
    font-family: "OnAir","FrutigerLight","Verdana","Tahoma","sans-serif";
  }

  .hardware-tile-checked {
    border: 2px solid #0019A5;
  }

  .hardware-tile {
    border: 1px solid #CCD5DD;
  }

  .combi-router-hint {
    font-size: 14px;
    border-radius: 4px 4px 0 0;
    background-color: #91C90E;
    text-align: left;
    height: 32px;
    align-items: center;
    display: flex;
    padding-left: 16px;
    color: #000066
  }

  .router-image-section {
    border: 1px solid #EAECEE;
    border-radius: 5.36px;
    height: 100%;
    background-color: white;
    margin-right: 24px;
  }
  .shop-tile-image-product {
    background-color: #EAECEE;
    width: 100%;
    height: 100%;
  }
  .router-icon-text {
    height: 20%;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    font-size: 12px;
  }

  .router-short-description {
    margin-bottom: 16px;
  }

  .select-Router-button {
    width: 142px;
    height: 48px;
    bottom: 0;
    right: 0;
    position: absolute;
    border-radius: 4px !important;
  }
  
  .router-price {
    width: 142px;
    right: 0;
    position: absolute;
    top: 15%;
    margin-bottom: 20px
  }
  
  .router-tile-section {
   padding: 0px;
   column-width: 100vw
  }
  .device-name {
  margin-bottom: 8px;
  font-size: 18px;
  }
  
  .product-details > p >a {
  margin: 0px !important
  }
}

@media only screen and (max-width: 767px) {
  .hardware-tile, .hardware-tile-checked {
    display: flex;
    flex-direction: column;
    padding: 16px;
    box-sizing: border-box;
    border-radius: 4px;
    background-color: #FFFFFF;
    cursor: pointer;
    font-family: "OnAir","FrutigerLight","Verdana","Tahoma","sans-serif";
  }

  .hardware-tile-checked {
    border: 2px solid #0019A5;
  }

  .hardware-tile {
    border: 1px solid #CCD5DD;
  }

  .combi-router-hint {
    font-size: 12px;
    border-radius: 4px 4px 0 0;
    background-color: #91C90E;
    text-align: center;
    height: 32px;
    align-items: center;
    display: flex;
    justify-content: center;
    color: #000066
  }

  .router-image-section, .router-short-description {
    display: none;
  }

  .select-Router-button {
    width: 100% !important;
    height: 32px;
    line-height: 0px;
    margin: 0;
  }
  
  .router-tile-section {
   padding: 0px;
  }
  
  .device-name {
  margin-bottom: 8px;
  font-size: 18px;
  }
  
  .router-price {
  margin-bottom: 20px
  }
  
  .product-details > p{
    margin-bottom: 20px
  }
}
        
         @media (min-width: 768px) {
           .router-section-header{
                font-size : 32px;
                line-height : 38.4px;
                margin-top: 12px;
                margin-bottom: 16px
            }
        }
    `;

  return (
        <>
            <style>{style}</style>
            <div>
                {hardwareOptions && (
                    <>
                        {accessType !== "DTAG-FTTH-ETH" &&
                        <>
                            <h1 className="shop-occl-tile-headline router-section-header"
                                 dangerouslySetInnerHTML={{ __html: cmsContent[CmsRouterContentIdentifier.GeneralRouterHeaderText] }}/>
                            {hardwareOptions.map((option, index) => (
                                !option.ownHardware &&
                                <HardwareTile
                                    key={option.articleId}
                                    checked={option.selected}
                                    hardwareOption={option}
                                    activationFeeText={cmsContent[CmsPageContentIdentifier.ActivationFeeText]}
                                    onClick={() => onHardwareOptionSelected(index, option)}
                                    selectedHardwareOption = {selectedHardwareOption}
                                />
                            ))}
                        </>
                        }
                        {accessType === "DTAG-FTTH-ETH" &&
                            <>
                                <div className="combi-router-section">
                                    {accessType === "DTAG-FTTH-ETH" && hardwareOptions.map((option, index) => (
                                        !option.ownHardware && option.hardwareClass === HardwareClass.OR &&
                                        <>
                                            <h1 className="combi-router-section-header router-section-header"
                                                 dangerouslySetInnerHTML={{ __html: cmsContent[CmsRouterContentIdentifier.CombiRouterHeaderText] }}/>
                                            <HardwareTile
                                                key={option.articleId}
                                                checked={option.selected}
                                                hardwareOption={option}
                                                activationFeeText={cmsContent[CmsPageContentIdentifier.ActivationFeeText]}
                                                onClick={() => onHardwareOptionSelected(index, option)}
                                                selectedHardwareOption = {selectedHardwareOption}
                                            />
                                        </>
                                    ))}
                                </div>
                                <div className="router-ont-section">
                                    {hardwareOptions.map((option, index) => (
                                        !option.ownHardware &&
                                        (option.hardwareClass === HardwareClass.R ) &&
                                        <>
                                            <h1 className="router-ont-section-header router-section-header"
                                                 dangerouslySetInnerHTML={{ __html: cmsContent[CmsRouterContentIdentifier.RouterAndOntHeaderText] }}/>
                                            <HardwareTile
                                                key={option.articleId}
                                                checked={option.selected}
                                                hardwareOption={option}
                                                activationFeeText={cmsContent[CmsPageContentIdentifier.ActivationFeeText]}
                                                onClick={() => onHardwareOptionSelected(index, option)}
                                                selectedHardwareOption = {selectedHardwareOption}
                                            />
                                        </>
                                    ))}
                                    {hardwareOptions.map((option, index) => (
                                        !option.ownHardware &&
                                        (option.hardwareClass === HardwareClass.O ) &&
                                        <>
                                            <HardwareTile
                                                key={option.articleId}
                                                checked={option.selected}
                                                hardwareOption={option}
                                                activationFeeText={cmsContent[CmsPageContentIdentifier.ActivationFeeText]}
                                                onClick={() => onHardwareOptionSelected(index, option)}
                                                selectedHardwareOption = {selectedHardwareOption}
                                            />
                                        </>
                                    ))}
                                </div>
                            </>
                        }
                        { isFmsTariff && (
                            <>
                                <ItemPanel onClick={onBuyHardwareTeaserClick}>
                                    <a
                                        dangerouslySetInnerHTML={
                                            {__html: cmsContent[CmsPageContentIdentifier.BuyHardwareTeaser]}
                                        }
                                    />
                                </ItemPanel>
                                <br/>
                            </>
                        )}
                        {hardwareOptions.map((option, index) => (
                            option.ownHardware &&
                            <OwnRouterComponent
                                routeHeader={cmsContent[CmsRouterContentIdentifier.OwnRouterHeaderText]}
                                checked={option.selected}
                                onClick={() => onHardwareOptionSelected(index, option)}
                                selectedHardwareOption = {selectedHardwareOption}
                                learnMore={cmsContent[CmsRouterContentIdentifier.OwnRouterLearnMore]}
                                accessType={accessType}
                                cmsContent={cmsContent}
                            />
                        ))}
                    </>
                )}
            </div>
        </>
    );
};

const mapStateToProps = (state: ReduxStateType): StateProps => ({
    hardwareOptions: getHardwareOptions(state),
    selectedHardwareOption: getSelectedHardwareOption(state),
    cmsContent: getCmsContent(state),
    accessType: getAccessType(state)
});

export default connect(mapStateToProps)(HardwareSelection);
